import React from 'react';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';

import AppContent from '../_Shared/Layout/AppContent';

const _ = require('lodash');

class ChannelEdit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            channel: props.channel
        }
    }

    componentDidMount() {
        this.props.onActivate();
    }
    
    componentDidUpdate(prevProps, prevState) {
        const { channel } = this.props;
        if (channel !== null && !_.isEqual(prevProps.channel, channel)) {
            this.setState({ channel });
        }
    }

    handleInputChange = (name, value) => {
        this.setState((prevProps, state) => {
            return { channel: Object.assign({}, prevProps.channel, { [name]: value }) }
        });
    }

    updateChannel = e => {
        const { onChannelUpdated } = this.props;
        const { channel } = this.state;
        onChannelUpdated(Object.assign({}, channel));
    }

    render() {
        const { loading } = this.props;
        const { channel } = this.state;
        return (<AppContent>
                    <Grid container spacing={24}> 
                        {
                            loading &&
                            <Grid container item spacing={24}><Grid item xs><LinearProgress variant="query" color="secondary" /></Grid></Grid>
                        }

                        <Grid container item spacing={24}>
                            <Grid item lg={6} xl={4}>
                                <TextField autoFocus value={channel.name} onChange={e => this.handleInputChange('name', e.target.value)} id="name" name="name" label="Channel Name" type="text" fullWidth />
                            </Grid>
                        </Grid>

                        <Grid container item spacing={24}>
                            <Grid item lg={6} xl={4}>
                                <Button onClick={this.updateChannel} variant="contained" color="secondary">Save</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </AppContent >)
    }
}
export default ChannelEdit;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Channels/ChannelEdit.js